var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patch-locations-template',{attrs:{"patch-locations":_vm.patchLocations,"other-patch-locations":_vm.otherPatchLocations,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }